module.exports = __webpack_public_path__ + "img/appstore-download.a6b08f9b.png";